<template>
  <component
    v-if="iconSet === 'lucide' && entry"
    :is="entry.lucide"
    :size="size"
    :stroke-width="strokeWidth"
    class="app-icon app-icon--lucide"
  />
  <span
    v-else-if="entry"
    class="app-icon app-icon--emoji"
    :style="{ fontSize: `${size}px`, lineHeight: `${size}px`, width: `${size}px`, height: `${size}px` }"
  >{{ entry.emoji }}</span>
  <span v-else class="app-icon app-icon--fallback" :style="{ fontSize: `${size}px` }">?</span>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useThemeStore } from '@/stores/theme'
import { getIconEntry } from '@/icons/registry'

const props = withDefaults(defineProps<{
  name: string
  size?: number
  strokeWidth?: number
}>(), {
  size: 16,
  strokeWidth: 2,
})

const themeStore = useThemeStore()
const iconSet = computed(() => themeStore.iconSet)

const entry = computed(() => {
  const e = getIconEntry(props.name)
  if (!e && import.meta.env.DEV) {
    console.warn(`[AppIcon] Unknown icon name: "${props.name}"`)
  }
  return e
})
</script>

<style scoped>
.app-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  vertical-align: middle;
}

.app-icon--emoji {
  text-align: center;
}

.app-icon--lucide {
  color: currentColor;
}
</style>
